<script lang="ts">
    import {resolveImageByUrl} from "$lib/helpers/brandsImageUrlResolver";

    export let brands: [];
</script>

<section class="bg-graybg py-8 w-full">
    <ul class="grid grid-cols-6  md:w-4/6 m-auto">
        {#each brands as brand}
            <li class="p-2">
                <a href="/skutry/{brand.lowerText}/" title="Zobrazit skútry od výrobce {brand.lowerText.charAt(0).toUpperCase() + brand.lowerText.slice(1)}" class="text-blue-500 hover:underline flex justify-center">
                    <img alt={"výrobce dílů a skútry " + brand.lowerText.charAt(0).toUpperCase() + brand.lowerText.slice(1)} src={resolveImageByUrl(brand.lowerText)} class="w-1/2"/>
                </a>
            </li>
        {/each}
    </ul>
</section>
